import CommonService from "./common.service";
import StorageService from "./StorageService";

function resolveShareUserId() {
  const user = StorageService.getUser();
  if (!user) return null;
  const id = Number(user.user_login_id ?? user.user_id ?? user.id);
  return Number.isFinite(id) && id > 0 ? id : null;
}

const marketplaceProductShareService = {
  trackShare(productId, sharePlatform) {
    const id = Number(productId);
    if (!Number.isFinite(id) || id <= 0 || !sharePlatform) return Promise.resolve();

    return CommonService.post(
      `/hub-home/products/${id}/share`,
      {
        share_platform: sharePlatform,
        user_id: resolveShareUserId(),
      },
      { silent: true },
    ).catch(() => {});
  },
};

export default marketplaceProductShareService;
